import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select
} from '@mui/material';
import { getCells, setSelectedCell } from 'actions/orderActions';
import SelectActiveAddressesMap from './SelectActiveAddressesMap';

const SelectActiveAddresses = ({
  cells,
  setSelectedCell,
  selectedCellId,
  getCells
}) => {
  useEffect(() => {
    getCells();
  }, []);

  const BALBRIGGAN_CELL_ID = 2;

  const handleCellUpdate = event => {
    localStorage.setItem('selectedCell', event.target.value);
    setSelectedCell(event.target.value);
  };

  const showCells = cells => {
    return cells?.map(cell => {
      return (
        <MenuItem key={`cell-${cell.id}`} value={cell.id}>
          {cell.cellName}
        </MenuItem>
      );
    });
  };

  return (
    <>
      <Box
        display="flex"
        mb={2}
        sx={{
          maxWidth: { md: 900, xl: 100000 },
          height: 72
        }}>
        <Box sx={{ width: 320, height: '100%' }}>
          <FormControl fullWidth style={{ width: 320, top: 20, left: 16 }}>
            <InputLabel>Cell</InputLabel>
            <Select
              value={selectedCellId}
              label="Cell"
              onChange={handleCellUpdate}>
              {showCells(cells)}
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Paper style={{ position: 'absolute', height: '100%', width: '100%' }}>
        <>
          <SelectActiveAddressesMap />
        </>
      </Paper>
    </>
  );
};

const mapStateToProps = state => ({
  cells: state.orders.cells,
  selectedCellId: state.orders.selectedCellId
});

const mapDispatchToProps = dispatch => ({
  getCells: () => dispatch(getCells()),
  setSelectedCell: cellId => dispatch(setSelectedCell(cellId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectActiveAddresses);
